export const isRTL = (element: HTMLElement) =>
  (element.closest('[dir]')?.getAttribute('dir') ??
    document.documentElement.dir) === 'rtl';
